"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tabs = void 0;
const react_1 = __importStar(require("react"));
const TabControl_1 = require("../TabControl");
const Tabs_styles_1 = require("./Tabs.styles");
const common_1 = require("../common");
/** A controlled component for rendering a list of tab buttons. */
const TabsInner = (_a, externalTabListRef) => {
    var { tabs: initTabs = [], activeTab, onActivate, elevation = 1, getTabControlId, getTabPanelId, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledby, renderAsNav = false } = _a, restProps = __rest(_a, ["tabs", "activeTab", "onActivate", "elevation", "getTabControlId", "getTabPanelId", 'aria-label', 'aria-labelledby', "renderAsNav"]);
    const tabs = (0, common_1.useTabObjects)(initTabs);
    const { 'aria-orientation': ariaOrientation, onKeyDown } = (0, common_1.useFocusManager)({
        orientation: 'horizontal'
    });
    const handleTabControlClick = (tab) => (event) => {
        event.persist();
        onActivate && onActivate(event, tab.id, tab);
    };
    return (react_1.default.createElement(Tabs_styles_1.TabList, Object.assign({ as: renderAsNav && 'nav', elevation: elevation, tabIndex: -1, role: renderAsNav ? 'navigation' : 'tablist', "aria-label": ariaLabel, "aria-labelledby": ariaLabelledby, "aria-orientation": ariaOrientation, onKeyDown: renderAsNav ? undefined : onKeyDown, ref: externalTabListRef }, restProps), tabs.map((tab, i) => {
        const tabControlId = getTabControlId(tab.id);
        const selected = tab.id === activeTab;
        const tabIndex = (0, common_1.getTabIndex)(activeTab, selected, i);
        return (react_1.default.createElement(TabControl_1.TabControl, { getTabPanelId: getTabPanelId, handleOnClick: handleTabControlClick, key: tab.id, renderAsNav: renderAsNav, tab: tab, selected: selected, tabControlId: tabControlId, tabIndex: tabIndex }));
    })));
};
exports.Tabs = (0, react_1.forwardRef)(TabsInner);
//# sourceMappingURL=Tabs.js.map